import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/ProtocoloGuia";

/**
 * Classe de gerenciamento de chamadas da API do ProtocoloGuia
 *
 * @class
 */

export default class ProtocoloGuiaApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe ProtocoloGuiaApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  PermissoesBuscar(usuarioProtocolo: { CodUsuario: number }) {
    return this.api<Record<string, boolean>>(`${controller}/Permissoes/Buscar`, {
      method: "POST",
      body: usuarioProtocolo,
    });
  }

  adicionarProtocolo(protocolo: any) {
    return this.api<number>(`${controller}/Protocolo/Adicionar`, {
      method: "POST",
      body: protocolo,
    });
  }

  listarProtocolos(dataInicio: string, dataFim: string) {
    return this.api<any[]>(`${controller}/ProtocoloGuia/Listar`, {
      method: "GET",
      params: { dataInicio, dataFim },
    });
  }

  listarLoteProtocoloGuia(codProtocolo: number) {
    return this.api<any[]>(`${controller}/LoteProtocoloGuia/Listar`, {
      method: "GET",
      params: { codProtocolo },
    });
  }

  listarGruposOperadora() {
    return this.api<any[]>(`${controller}/GrupoOperadora/Listar`, {
      method: "GET",
    });
  }

  listarOperadoras() {
    return this.api<any[]>(`${controller}/Operadora/Listar`, {
      method: "GET",
    });
  }

  listarUnidades() {
    return this.api<any[]>(`${controller}/Unidade/Listar`, {
      method: "GET",
    });
  }

  listarUsuarios() {
    return this.api<any[]>(`${controller}/Usuario/Listar`, {
      method: "GET",
    });
  }

  listarGuias(
    dataInicio: string,
    dataFim: string,
    codOperadora: number,
    codGrupoOperadora: number,
  ) {
    return this.api<any[]>(`${controller}/Guias/Listar`, {
      method: "GET",
      params: { dataInicio, dataFim, codOperadora, codGrupoOperadora },
    });
  }

  buscarGuia(codGuia: number, codProtocolo: number) {
    return this.api<any>(`${controller}/Guia/Listar`, {
      method: "GET",
      params: { codGuia, codProtocolo },
    });
  }

  adicionarGuia(guia: any) {
    return this.api<number>(`${controller}/Guia/Adicionar`, {
      method: "POST",
      body: guia,
    });
  }

  alterarGuia(guia: any) {
    return this.api<number>(`${controller}/Guia/Alterar`, {
      method: "POST",
      body: guia,
    });
  }

  deletarGuia(loteProtocolo: any) {
    return this.api<number>(`${controller}/Guia/Delete`, {
      method: "POST",
      body: loteProtocolo,
    });
  }

  atualizarColuna(ini: any) {
    return this.api<number>(`${controller}/Coluna/Update`, {
      method: "POST",
      body: ini,
    });
  }

  listarColunas(ini: any) {
    return this.api<any[]>(`${controller}/Colunas/Listar`, {
      method: "POST",
      body: ini,
    });
  }
}
